const setupSocket = (
  url,
  handler,
  appEntityId,
  agentTeamsToken,
  password,
  setIsAuthenticated
) => {
  let hasConnectedBefore = false;
  const socket = new WebSocket(
    url + `/agent?appEntityId=${appEntityId}&password=${password}`
  );
  socket.binaryType = "arraybuffer";
  socket.emit = (type, ...args) => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ type, args: args || [] }));
    }
  };

  socket.onmessage = (event) => {
    try {
      const { type, args } = JSON.parse(event.data);
      if (type === "ping") {
        return socket.emit("pong");
      }
      handler(type, args);
    } catch (e) {
      console.error("could not handle message " + e);
    }
  };

  socket.onopen = () => {
    hasConnectedBefore = true;
    socket.emit("connect", {
      message: "Server Connected to Client",
      agentTeamsToken,
    });
    socket.emit("pong");
  };

  socket.onclose = () => {
    if (hasConnectedBefore) {
      handler("disconnect", []);
    } else {
      setIsAuthenticated(false);
    }
  };

  return socket;
};

export default (url, handler, roomId, agentId, password, setIsAuthenticated) =>
  setupSocket(url, handler, roomId, agentId, password, setIsAuthenticated);
